import { jsx as _jsx } from "react/jsx-runtime";
import ScallopedImage from '@marketing/components/global/misc/ScallopedImage';
import { useMediaQuery } from '@mui/material';
var WaypointScallop = function (_a) {
    var imageData = _a.imageData;
    var isMobile = useMediaQuery('(max-width: 768px)');
    return (_jsx(ScallopedImage, { size: isMobile ? 'small' : 'large', imgData: imageData, height: isMobile ? 180 : 351, theme: "light", use: "funnel" }));
};
export default WaypointScallop;
